import React from "react";
import { revisarPresupuesto } from "../helper";
import PropTypes from "prop-types";

export default function ControlPresupuesto({ presupuesto, restante }) {
	return (
		<React.Fragment>
			<div className="alert alert-primary">
				Presupuesto: ${presupuesto}
			</div>
			<div className={revisarPresupuesto(presupuesto, restante)}>
				Restante: $ {restante}
			</div>
		</React.Fragment>
	);
}

ControlPresupuesto.propTypes = {
	presupuesto: PropTypes.number.isRequired,
	restante: PropTypes.number.isRequired,
};
